export const ticketStorageKeys = {
  // Stored in session storage
  residentFocusMode: () => `resident-focus`,
  filters: (projectId: string) => `${projectId}-ticket-filters` as const,
  portfolio_filters: () => `portfolio-ticket-filters`,
  // Stored in local storage
  tabSort: () => `tab-sorting`,
} as const;
